import { useIonViewWillEnter, IonBadge, IonInfiniteScrollContent, IonInfiniteScroll, IonTextarea, IonFooter, IonList, IonGrid, IonSpinner, IonApp, IonContent, IonPage, IonHeader, IonTitle, IonButtons, IonModal, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { eyeOutline, checkmarkDoneOutline, checkmarkCircleOutline, eye, sendOutline, addOutline, closeOutline, chatboxOutline, heartCircleOutline, heartOutline, chatbubbleEllipses, earth, heart, heartCircle } from 'ionicons/icons';
import React, { useRef, useState, useEffect }  from 'react';
import { createAnimation } from '@ionic/react';

import NServer, { UIElement } from "../components/NServer";
import { showAlert } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";

import LikeComp from "../components/LikeComp";
import Comment from "../components/Comment";
import ReactionBar from "../components/ReactionBar";
import CommentBox from "../components/CommentBox";
import LikeErrComp from "../components/LikeErrComp";
import { ReadyAds, ShowAds } from "../components/Admob";

import { ContentInfo, ContentInterface, ContentUpdateInt, ItemInfo, CommentInfo, CountNum, FilterUniqueContent } from '../data/item';

import '../pages/Main.css'; 
import '../pages/ChatMsg.css'; 

var com_index = 0;
const com_total = 10;
var reply_mode = false;

const LikeBar : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const [likes, setLikes] = useState(0);
    const [commentBox, showComments] = useState(false);
    const [likeBox, showLikes] = useState(false);
    const [firstLike, showFirstLike] = useState(false);
    const [superLikeInfo, showSuperLikeInfo] = useState(false);
    
    const [supporterLoading, setSupporterLoading] = useState(false);
    const [supporters, setSupporters] = useState<ItemInfo[]>([]);
    const [comments, setComments] = useState<CommentInfo[]>([]);
    const [commentLoading, setCommentLoading] = useState(false);
    const [msg, setMsg] = useState("");

    const inputRef = useRef<HTMLIonTextareaElement | null>(null);
    const [canSend, setCanSend] = useState(false);
    const [noMoreComment, setNoMoreComment] = useState(false);
    const [replyComment, setReplyComment] = useState<CommentInfo | null>(null);
    const [replyOnly, setReplyOnly] = useState(false);
    const [likeError, showLikeError] = useState(false);
    const [adReady, setAdReady] = useState(false);
    const [showLikeList, setShowLikeList] = useState(false);

    const heartRef = useRef<any>();
    const superHeartRef = useRef<any>();

    const router = useIonRouter();

    // need to refresh
    useEffect(() => {
        if (view == "full")
        {
            // load the comment for full view
            setShowLikeList(false);
            com_index = 0;
            setNoMoreComment(false);
            setReplyOnly(content.reply_only);
            getComments(content.reply_only);
        }
    },[content]);

    // click on like bars
    const clickLikeBar = () => {
        if (view == "full")
        {
            // simply show comment in full view
            setShowLikeList(true);
            getSupporters();
            return;
        }

        if (supporters.length == 0)
            setSupporterLoading(true);

        // load the supporters
        getSupporters();

        showLikes(true);
    }

    // click on the comment
    const onComment = () => {
        if (view == "full")
        {
            // simply show comment in full view
            setShowLikeList(false);
            return;
        }

        if (comments.length == 0)
            setCommentLoading(true);

        setReplyOnly(false);

        // load the supporters
        getComments(false);

        showComments(true);
    }

    const closeComment = () => {
        // reset
        com_index = 0;
        setNoMoreComment(false);

        showComments(false);
    }

    // send a like
    const sendLike = async (total : number, ano : boolean) => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            likes: total,
            ano: ano ? 1 : 0
        }

		var server = new NServer();
        await server.sendForm("nc_like", state);

        if (server.data.nolike == 1)
        {
            let ready = await ReadyAds();
            setAdReady(ready);
            showLikeError(true);
            return;
        }

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            if (server.data.has_token == "no")
            {
                showAlert(GetStr(LANGUAGE.TXT_NO_NTOKEN_LIKE));
            }
        }
    }

    // when like is clicked
    const onLike = async () => {
        let firstTime = await FirstTime("like");
        if (firstTime)
        {
            showFirstLike(true);
            return;
        }

        if (heartRef.current !== null) {
            const animation = createAnimation()
                .addElement(heartRef.current)
                .duration(500)
                .keyframes([
                    { offset: 0, transform: 'scale(1)' },
                    { offset: 0.5, transform: 'scale(1.5)', fill:'#D0FF10' },
                    { offset: 1, transform: 'scale(1)' }
                ])
                .easing('ease-out');
            animation.play();
        }

        // local update first for better UX
        content.likes = parseInt("" + content.likes) + 1;
        content.user_likes = parseInt("" + content.user_likes) + 1;
        // unlock data if it is locked
        if (content.locked == 1)
            content.opening = true;
        
        onUpdate(index, content, true);
        
        // send a like
        await sendLike(1, false);

        onUpdate(index, content, false);

        if (likeBox)
            getSupporters();
    }

    // when super like is clicked
    const onSuperLike = async () => {
        let firstTime = await FirstTime("super");
        if (firstTime)
        {
            showSuperLikeInfo(true);
            return;
        }

        if (superHeartRef.current !== null) {
            const animation = createAnimation()
                .addElement(superHeartRef.current)
                .duration(1000)
                .keyframes([
                    { offset: 0, transform: 'scale(1)' },
                    { offset: 0.5, transform: 'scale(1.8)', fill:'#FF38F6' },
                    { offset: 1, transform: 'scale(1)' }
                ])
                .easing('ease-out');
            animation.play();
        }

        // local update first for better UX
        content.likes = parseInt("" + content.likes) + 10;
        content.user_likes = parseInt("" + content.user_likes) + 10;
        // unlock data if it is locked
        if (content.locked > 1)
            content.opening = true;

        onUpdate(index, content, true);
        
        // send 10 likes
        await sendLike(10, false);

        onUpdate(index, content);

        if (likeBox)
            getSupporters();
    }

    // when like is clicked
    const onHiddenLike = async () => {
        
        // local update first for better UX
        content.likes = parseInt("" + content.likes) + 1;
        
        onUpdate(index, content, true);
        
        // send a like
        await sendLike(1, true);

        onUpdate(index, content, false);

        if (likeBox)
            getSupporters();
    }

    // when super like is clicked
    const onHiddenSuperLike = async () => {
        // local update first for better UX
        content.likes = parseInt("" + content.likes) + 10;
        
        onUpdate(index, content, true);
        
        // send 10 likes
        await sendLike(10, true);

        onUpdate(index, content);

        if (likeBox)
            getSupporters();
    }

    // go to n-tokens wallet
    const getNTokens = () => {
        showFirstLike(false);
        router.push("/token/wallet", "forward", "push");
    }

    // load the supporters
    const getSupporters = async () => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
        }

		var server = new NServer();
        await server.getList("nc_supporters", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setSupporters(server.data);
            setSupporterLoading(false);
        }
    }

    // click on item
    const onLikeUserClicked = (item : ItemInfo) => {
        showLikes(false);
        if (item != null)
            router.push("/user/" + item.id, "forward", "push");
    }

    const processSendMsg = (e : any, img : string, ano : boolean) => {
        if (inputRef.current != null)
        {
            if (e.clientX >= inputRef.current.getBoundingClientRect().right)
            {
                // trigger the button
                sendMsg(img, ano);
                setReplyComment(null);
            }
        }
    }

    // update the message
    const updateMsg = (val : string) => {
        if (val != '')
            setCanSend(true);
        else
            setCanSend(false);

        setMsg(val);
    }

    // load the supporters
    const getComments = async (rmode : boolean) => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            reply: rmode ? 1 : 0,
            s : com_index,
            e : com_total
        }

		var server = new NServer();
        await server.getList("nc_comments", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            let com_list = server.data;
            if (com_index > 0)
                com_list = comments.concat(server.data);
            com_list = FilterUniqueContent(com_list);
            setComments(com_list);

            if (server.data.length < com_total)
                setNoMoreComment(true);
        }

        setCommentLoading(false);
    }

    const loadMoreComments = (ev: any) => {
        setTimeout(() => {
            // increase index
            com_index += com_total;

            getComments(reply_mode);

            ev.target.complete();
        }, 500);
    }  

    // send the message
    const sendMsg = async (img : string, ano : boolean) => {
        if (msg == "" && img == "")
            return;

        let v = new Vault();
        await v.read();

        let reply_id = -1;
        if (replyComment != null)
            reply_id = replyComment.id;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            msg: msg,
            img : img,
            ref: reply_id,
            ano: ano ? 1 : 0
        }

		var server = new NServer();
        await server.sendForm("nc_send_comment", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            await getComments(reply_mode);

            onUpdate(index, content, false);
            
            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }

    // send the GIF message
    const sendGif = async (gif : string, ano : boolean) => {
        if (gif == "")
            return;

        // clear reply
        setReplyComment(null);

        let v = new Vault();
        await v.read();

        let reply_id = -1;
        if (replyComment != null)
            reply_id = replyComment.id;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            msg: gif,
            ref: reply_id,
            ano: ano ? 1 : 0
        }

		var server = new NServer();
        await server.sendForm("nc_send_gif", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            await getComments(reply_mode);

            onUpdate(index, content, false);
            
            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }

    // click on user
    const userClick = (comment: CommentInfo) => {
        showComments(false);
        if (comment != null)
            router.push("/user/" + comment.user, "forward", "push");
    }

    // update the comment list
    const updateComments = async () => {
        await getComments(reply_mode);
    }

    // reply to comment
    const setRepliedComment = (com : CommentInfo) => {
        // full view need to handle reply comment differently
        if (view == "full")
        {
            onUpdate(-2, com);
            return;
        }

        setReplyComment(com);
    }

    // toggle the comment reply mode
    const toggleReplyMode = () => {
        reply_mode = !replyOnly;
        setReplyOnly(reply_mode);

        com_index = 0;
        getComments(reply_mode);
    }

    // watch an Ads
    const watchAds = () => {
        setAdReady(false);
        showLikeError(false);
        
        // show the ads
        ShowAds( () => {
            
        });
    }

    // else
    return (
        <div className={ view=="video" ? "fullscreen-likebar-parent" : "" }>
            {
                /* like and view bar */
                view != "video" ?
            <IonItem className="likes-bar ion-activatable ripple-parent" lines="full" onClick={clickLikeBar}>
                <div slot="end">
                    <IonText className="like-cmt-view">{CountNum(content.likes)} Likes&nbsp;&nbsp;{CountNum(content.comments)} Comments&nbsp;&nbsp;{CountNum(content.views)} Views</IonText>
                </div>
                <div slot="start" className="supporter-list">
                    {
                        content.supporters.map((m, index) => 
                            <IonAvatar className="sup-avatar" key={index} slot="start">
                                <img src={m} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                            </IonAvatar>
                        )
                    }
                </div>
                <IonRippleEffect></IonRippleEffect>
            </IonItem>
                :
            <div/>
            }
            {
                /* like buttons bar */
                view == "video" ?
            <div className="fullscreen-likebar-wrapper">
                <IonButton className="anim-wrapper white-shadow fullscreen-likebar" fill="clear"  >
                    <div className="vert-but">
                        <IonIcon icon={eyeOutline} size="large" />
                        <IonLabel>{ CountNum(content.views) }</IonLabel>
                    </div>
                </IonButton>
                <IonButton className="anim-wrapper white-shadow fullscreen-likebar" fill="clear" color={content.user_likes >= 1 ? "primary" : ""} onClick={onLike} >
                    <div className="vert-but">
                        <IonIcon ref={heartRef} icon={content.user_likes >= 1 ? heart : heartOutline} size="large" />
                        <IonLabel>{ content.likes }</IonLabel>
                    </div>
                </IonButton>
                <br/>
                <IonButton className="anim-wrapper white-shadow fullscreen-likebar" fill="clear" color={content.user_likes >= 10 ? "primary" : ""} onClick={onSuperLike} >
                    <div className="vert-but">
                        <IonIcon ref={superHeartRef} icon={content.user_likes >= 10 ? heartCircle : heartCircleOutline} size="large" />
                        <IonLabel>{ Math.floor(content.likes/10) }</IonLabel>
                    </div>
                </IonButton>
                <br/>
                <IonButton className="white-shadow fullscreen-likebar" slot="end" fill="clear" onClick={onComment}>
                    <div className="vert-but">
                        <IonIcon icon={chatboxOutline} size="large" />
                        <IonLabel>{ content.comments }</IonLabel>
                    </div>
                </IonButton>
            </div>
                :
            <IonItem lines="none">
                <IonButton className="anim-wrapper" fill="clear" color={content.user_likes >= 1 ? "primary" : "dark"} onClick={onLike} >
                    <IonIcon ref={heartRef} icon={content.user_likes >= 1 ? heart : heartOutline} size="large" />
                    &nbsp;Like
                </IonButton>
                <IonButton className="anim-wrapper" fill="clear" color={content.user_likes >= 10 ? "primary" : "dark"} onClick={onSuperLike} >
                    <IonIcon ref={superHeartRef} icon={content.user_likes >= 10 ? heartCircle : heartCircleOutline} size="large" />
                    &nbsp;Super
                </IonButton>
                <IonButton slot="end" fill="clear" color="dark" onClick={onComment}><IonIcon icon={chatboxOutline} size="large" />&nbsp;Comment</IonButton>
            </IonItem>
            }
            
            {
                // reaction bar only shown in def mode
                view == "def" ?
            <ReactionBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
                :
            <div/>
            }

            {
                // add comment bars
                view == "full" ?
                (
                    showLikeList ?
                    /* Likes section */
                <div>
                    {
                        supporters.length == 0 ?
                    <div className="ion-margin ion-text-center pad-space">
                        <IonText color="medium">{ GetStr(LANGUAGE.TXT_NO_LIKE_POST) }</IonText>
                    </div>
                        :
                    <IonList className="fullscreen bg-transparent">
                        <IonItem lines="none"><IonLabel>{ GetStr(LANGUAGE.TXT_SUPPORTERS) }</IonLabel></IonItem>
                        { 
                            supporters.map((m) => 
                            <LikeComp key={m.id} item={m} submit={onLikeUserClicked} />
                            )
                        }
                    </IonList>
                    }
                </div>
                    :
                    (commentLoading ?
                <div className="halfCenter pad-space">
                    <IonSpinner name="crescent" />
                </div>
                    :
                    comments.length == 0 ?
                <div className="halfCenter pad-space">
                    <IonText color="medium">{ GetStr(LANGUAGE.TXT_NO_COMMENT_POST) }</IonText>
                </div>
                    :
                <div>
                    <IonList class="bg-transparent">
                        { 
                            comments.map((m) => 
                            <Comment key={m.id} comment={m} onUser={userClick} onUpdate={updateComments} onReply={setRepliedComment} />
                            )
                        }
                    </IonList>
                    <IonInfiniteScroll
                        onIonInfinite={loadMoreComments}
                        disabled={noMoreComment}
                    >
                        <IonInfiniteScrollContent
                            className="ion-no-padding"
                            loadingSpinner="crescent"
                        ></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </div>
                    ))
                    :
                <div/>
            }

            { /* comment box */ }
            <IonModal
                isOpen={commentBox}
                initialBreakpoint={ 1 }
                onDidDismiss={closeComment}>
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonTitle><h5>{ GetStr(LANGUAGE.TXT_COMMENT_CAP) }</h5></IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={ toggleReplyMode }>
                                <IonIcon icon={ replyOnly ? checkmarkDoneOutline : checkmarkCircleOutline} />&nbsp;
                                { GetStr(replyOnly ? LANGUAGE.TXT_CMT_REPLY_ALL : LANGUAGE.TXT_CMT_REPLY_ONLY) }
                            </IonButton>
                            <IonButton onClick={closeComment}>
                                <IonIcon icon={closeOutline} size="large"/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        {
                            commentLoading ?
                        <div className="halfCenter">
                            <IonSpinner name="crescent" />
                        </div>
                            :
                            comments.length == 0 ?
                        <div className="halfCenter">
                            <IonText color="medium">{ GetStr(LANGUAGE.TXT_NO_COMMENT_POST) }</IonText>
                        </div>
                            :
                        <div>
                            <IonList class="bg-transparent">
                                { 
                                    comments.map((m) => 
                                    <Comment key={m.id} comment={m} onUser={userClick} onUpdate={updateComments} onReply={setRepliedComment} />
                                    )
                                }
                            </IonList>
                            <IonInfiniteScroll
                                onIonInfinite={loadMoreComments}
                                disabled={noMoreComment}
                            >
                                <IonInfiniteScrollContent
                                    className="ion-no-padding"
                                    loadingSpinner="crescent"
                                ></IonInfiniteScrollContent>
                            </IonInfiniteScroll>
                        </div>
                        }
                    </IonContent>
                    <IonFooter>
                        <CommentBox inputRef={inputRef} updateMsg={updateMsg} replyComment={replyComment} clearReply={()=>setReplyComment(null)} sendMsg={processSendMsg} sendGif={sendGif} />
                    </IonFooter>          
                </div>
            </IonModal>

            { /* likes box */ }
            <IonModal
                isOpen={likeBox}
                initialBreakpoint={ 1 }
                onDidDismiss={() => showLikes(false)}>
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonItem className="like-bar-full" slot="start" color="none" lines="none">
                            <IonButton className="small-like" fill="clear" color={content.user_likes >= 1 ? "primary" : "dark"} onClick={onLike} >
                                <IonIcon icon={content.user_likes >= 1 ? heart : heartOutline} size="large" />
                                Like
                            </IonButton>
                            <IonButton className="small-like" fill="clear" color={content.user_likes >= 10 ? "primary" : "dark"} onClick={onSuperLike} >
                                <IonIcon icon={content.user_likes >= 10 ? heartCircle : heartCircleOutline} size="large" />
                                Super
                            </IonButton>
                            
                            { /* anonymous likes */ }
                            <IonButton className="small-like" fill="clear" color="dark" onClick={onHiddenLike} >
                                <IonIcon icon={heartOutline} size="large" />
                                ???
                            </IonButton>
                            <IonButton className="small-like" fill="clear" color="dark" onClick={onHiddenSuperLike} >
                                <IonIcon icon={heartCircleOutline} size="large" />
                                ???
                            </IonButton>
                        </IonItem>
                        <IonButtons slot="end">
                            <IonButton onClick={()=>{showLikes(false)}}>
                                <IonIcon icon={closeOutline} size="large"/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        {
                            supporterLoading ?
                        <div className="headerCenter">
                            <IonSpinner name="crescent" />
                        </div>
                            :
                            supporters.length == 0 ?
                        <div className="headerCenter">
                            <IonText color="medium">{ GetStr(LANGUAGE.TXT_NO_LIKE_POST) }</IonText>
                        </div>
                            :
                        <IonList>
                            { 
                                supporters.map((m) => 
                                <LikeComp key={m.id} item={m} submit={onLikeUserClicked} />
                                )
                            }
                        </IonList>
                        }
                    </IonContent>
                </div>
            </IonModal>

            { /* first like info */ }
            <IonModal
                isOpen={firstLike}
                initialBreakpoint={ 0.95 }
                onDidDismiss={() => showFirstLike(false)}>
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonTitle><h5>{ GetStr(LANGUAGE.TXT_FIRSTLIKE_CAP) }</h5></IonTitle>
                    </IonToolbar>
                    <IonContent>
                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol>
                                    <div><IonImg className="info-pic" src="/assets/img/heart_pic.png" /></div>
                                    <div><IonText>{ GetStr(LANGUAGE.TXT_FIRSTLIKE_DESC) }</IonText></div>
                                    <div>
                                        <IonButton className="main-but ion-margin-top" expand="block" onClick={()=> showFirstLike(false)}>
                                            { GetStr(LANGUAGE.TXT_FIRSTLIKE_CLOSE) }
                                        </IonButton>
                                        <IonButton className="main-but ion-margin-top" color="secondary "expand="block" onClick={getNTokens}>
                                            { GetStr(LANGUAGE.TXT_GET_NTOKEN_BUT) }
                                        </IonButton>
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </div>
            </IonModal>

            { /* super like info */ }
            <IonModal
                isOpen={superLikeInfo}
                initialBreakpoint={ 0.95 }
                onDidDismiss={() => showSuperLikeInfo(false)}>
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonTitle><h5>{ GetStr(LANGUAGE.TXT_SUPER_LIKE_CAP) }</h5></IonTitle>
                    </IonToolbar>
                    <IonContent>
                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol>
                                    <div><IonImg className="info-pic" src="/assets/img/heart_pic.png" /></div>
                                    <div><IonText>{ GetStr(LANGUAGE.TXT_SUPER_LIKE_DESC) }</IonText></div>
                                    <div>
                                        <IonButton className="main-but ion-margin-top" expand="block" onClick={()=> showSuperLikeInfo(false)}>
                                            { GetStr(LANGUAGE.TXT_FIRSTLIKE_CLOSE) }
                                        </IonButton>
                                        <IonButton className="main-but ion-margin-top" color="secondary "expand="block" onClick={getNTokens}>
                                            { GetStr(LANGUAGE.TXT_GET_NTOKEN_BUT) }
                                        </IonButton>
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </div>
            </IonModal>

            { /* like error dialogbox */ }
            <LikeErrComp  isOpen={ likeError } onDidDismiss={ () => showLikeError(false) } adReady={ adReady } watchAds={ watchAds }  />
        </div>
    );
};
  
export default LikeBar;